import React, { useCallback } from "react";
import { useDispatch, useStore } from "react-redux";
import { Button } from "react-bootstrap";

import { useNavigate } from "../utils/components/router";
import { pageActions, basketActions, configActions } from "../actions";
import { Tooltip } from "../utils/components/Tooltip";

const BackToStartButton = (props) => {
  const { onClick, className } = props || {};
  const { configStorage } = useStore().getState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const contextNavigate = configStorage.contextNavigate(navigate);


  const handleClick = useCallback(() => {
    if (typeof onClick === "function") {
      onClick();
    }
    dispatch(configActions.setRenderLandingPage(true));
    dispatch(pageActions.setOverviewPage());
    dispatch(basketActions.resetWarenkorb());
    contextNavigate(configStorage.getBackToLandingPageLink());
  }, [configStorage, contextNavigate, dispatch, onClick]);

  if (!configStorage.isVerseNeo() && !configStorage.isDeuBa()) return null;
  if (configStorage.isKundenShop()) {
    return <Button
      className={(className || "") + " w-auto"}
      variant="default"
      onClick={handleClick}
    >
      <span className="text-center w-auto me-1">Zur Kontoauswahl</span>
    </Button>;
  }
  return <Button
    className={(className || "") + " w-auto"}
    variant="default"
    onClick={handleClick}
  >
    <span className="text-center w-auto me-1">Zu Auftragsart + Konto</span>
    <Tooltip className="text-center text-primary deuba_hover">
      Zurück zur Startseite und Auswahl "Bestellung/Ankauf".
      Insbesondere dann hilfreich, wenn man die Auftragsart wechseln möchte.
      Eine erneute Auswahl des Kunden ist nicht erforderlich.
    </Tooltip>
  </Button>;
};

export default BackToStartButton;
